import React, { Component, Fragment } from 'react';

import MediaItem from './MediaItem';

import Media from 'react-media';

function FadeInSection(props) {
    const [isVisible, setVisible] = React.useState(false);
    const domRef = React.useRef();
    React.useEffect(() => {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => setVisible(entry.isIntersecting));
      });
      observer.observe(domRef.current);
    }, []);
    return (
      <div
        className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}
        ref={domRef}
      >
        {props.children}
      </div>
    );
  }

class MediaField extends Component {

    render() {
        return (
            <React.Fragment>
              <Media queries={{
                narrow: "(max-width: 1049px)",
                medium: "(min-width: 1050px) and (max-width: 1250px)",
                wide: "(min-width: 1251px)"
              }}>
              {matches => (
                            <Fragment>
                                {matches.narrow && 
                                <Fragment>
                                  <div style={mediaWrapper}>
                                    {this.props.media.map((med) => {
                                      return (
                                        <MediaItem media={med} />
                                      )
                                    })}
                                  </div>
                                </Fragment>}
                                {matches.medium &&  
                                <Fragment>
                                  <div style={mediaWrapperMedium}>
                                    {this.props.media.map((med) => {
                                      return (
                                        <MediaItem media={med} />
                                      )
                                    })}
                                  </div>
                                </Fragment>}
                                {matches.wide &&  
                                <Fragment>
                                  <div style={mediaWrapper}>
                                    {this.props.media.map((med) => {
                                      return (
                                        <MediaItem media={med} />
                                      )
                                    })}
                                  </div>
                                </Fragment>}
                              </Fragment>
              )}
              </Media>
              </React.Fragment>
          ) 
    }
}

const mediaWrapper = {
  maxWidth: '1200px',
  display: 'flex',
  flexFlow: 'row wrap',
  flexShrink: '1',
  margin: 'auto'
}

const mediaWrapperMedium = {
  width: '950px',
  display: 'flex',
  flexFlow: 'row wrap',
  flexShrink: '1',
  margin: 'auto'
}

export default MediaField;